import { html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { BaseElement } from '../base/base-element.js';

/**
 * A toggle button for count-in functionality.
 *
 * @fires count-in-change - Fired when the toggle state changes (detail: { active: boolean })
 */
@customElement('count-in-toggle')
export class CountInToggle extends BaseElement {
    static styles = [
        BaseElement.styles,
        css`
            :host {
                display: inline-block;
            }

            button {
                display: flex;
                align-items: center;
                background: #333;
                border: none;
                border-radius: 1rem;
                padding: 0.25rem 0.5rem;
                color: #999;
                font-size: 0.85rem;
                cursor: pointer;
                transition: all 0.2s;
            }

            button:hover:not([disabled]) {
                background: #444;
            }

            button[disabled] {
                opacity: 0.5;
                cursor: not-allowed;
            }

            :host([active]) button {
                background: var(--primary-color, #2563eb);
                color: white;
            }

            :host([active]) button:hover:not([disabled]) {
                background: var(--primary-dark, #1e40af);
            }
        `,
    ];

    @property({ type: Boolean, reflect: true })
    active = false;

    @property({ type: Boolean, reflect: true })
    disabled = false;

    private _handleClick(): void {
        if (this.disabled) return;
        this.active = !this.active;
        this.dispatchEvent(
            new CustomEvent('count-in-change', {
                bubbles: true,
                composed: true,
                detail: { active: this.active },
            })
        );
    }

    render() {
        return html`
            <button
                ?disabled=${this.disabled}
                @click=${this._handleClick}
                aria-pressed=${this.active}
            >
                <span>Count-In</span>
            </button>
        `;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'count-in-toggle': CountInToggle;
    }
}
